// extracted by mini-css-extract-plugin
export default {"timePeriodSelect":"time-period-select_timePeriodSelect__ofpbm","timePeriodLabel":"time-period-select_timePeriodLabel__Z-RN6"};